<template>
  <div class="rhd-card">
    <div class="list-title">
      <el-row :gutter="20">
        <el-col :span="3"><div>产品名称</div></el-col>
        <el-col :span="3"><div>投/被保人</div></el-col>
        <el-col :span="5"><div>人核状态</div></el-col>
        <el-col :span="2"><div style="white-space: nowrap;">保费（元）</div></el-col>
        <el-col :span="2"><div>是否支付</div></el-col>
        <el-col :span="5"><div>订单号</div></el-col>
        <el-col :span="4"><div>操作</div></el-col>
      </el-row>
    </div>
    <div v-for="(item, index) in orderList" :key="index">
      <div class="table-info">
        <div>创建时间：{{ item.createTime|timeStatus }}</div>
        <div>投保单号：{{ item.policyNo | filterEmpty }}</div>
        <div v-if="userinfo.level!=3" class="order-mechan">
            <div class="mechan-info" v-if="['1','2'].includes(item.mechanLevel)">
              <div class="left">出单机构：</div>
              <div class="right">{{ item.mechanShortName }}</div>
            </div>
            <div class="mechan-info" v-else>
              <div class="left">出单员工：</div>
              <div class="right">{{ item.mechanShortName }}</div>
            </div>
        </div>
      </div>
      <div class="card" >
        <div class="card-content">
          <el-row :gutter="20">
            <el-col :span="3">
              <tooltip class="tbd-card" :txt-info=" item.productName | filterEmpty"></tooltip>
            </el-col>
            <el-col :span="3"
              >
              <tooltip class="tbd-card" :txt-info="(item.policyerName ||'-') +'/'+ (item.insuranceName ||'-')"></tooltip>
              </el-col
            >
            <el-col :span="5">
              <div>
                {{ filterHbStatus(item.orderStatus)}}
                <span v-if="['7','1','2','3','5','9','-9','4','8','6'].includes(item.orderStatus) && item.manualStatus">-</span>
                <span :class="{'green':['1','2','3','5','9','-9'].includes(item.orderStatus),'red':['4','6'].includes(item.orderStatus)}" v-show="item.manualStatus&&item.manualStatus.length<=8">{{ item.manualStatus||'-' }}</span>
                <el-tooltip class="item" effect="dark" placement="top">
                  <span :class="{'green':['1','2','3','5','9','-9'].includes(item.orderStatus),'red':['4','6'].includes(item.orderStatus)}" class="tbd-card" v-show="item.manualStatus&&item.manualStatus.length>8">
                    {{ item.manualStatus?item.manualStatus.substr(0,8):'-' }}
                    <span class="ellipsis">...</span>
                  </span>
                  <div class="tips" slot="content">{{filterHbStatus(item.orderStatus)+'-'+item.manualStatus}}</div>
                </el-tooltip>
              </div>
            </el-col>
            <el-col :span="2"
              ><div>{{ item.fee | filterEmpty}}</div></el-col
            >
            <el-col :span="2">
              <div>
                <el-badge value=""
                  ><span>{{
                    item.payStatus==1?'已支付':'未支付'
                  }}</span></el-badge
                >
              </div></el-col
            >
            <el-col :span="5"
              ><div>{{ item.id || "-" }}</div></el-col
            >
            <el-col :span="4"
              ><div class="card-btn">
                <el-button class="xq-btn copy" type="primary" @click="getDetail(item.jumpManualUrl)" plain
                  >核保详情</el-button
                >
                <el-popover popper-class="gd-popper" placement="right-start" width="90" trigger="click">
                  <ul class="more">
                    <li @click="getOrderDetail(item.id,item.mechanShortName,item.mechanLevel)">订单详情</li>
                    <li @click="copys(item.jumpManualUrl)" class="copys">复制核保链接</li>
                    <li @click="sendMsg(item.id)">发送进度通知</li>
                  </ul>
                  <el-button slot="reference" type="text">更多<i class="el-icon-arrow-down"></i></el-button>
                </el-popover>
              </div></el-col
            >
          </el-row>
        </div>
      </div>
    </div>
    <div class="empty" v-if="orderList.length==0">
      <p>
        <img src="@static/images/no_msg.png" style="width:290px"/>
      </p>
      <p><span>暂无数据</span></p>
    </div>
  </div>
</template>

<script>
import tooltip from "@/components/tooltip";
export default {
  props: {
    orderList: Array,
    selectForm:Object,
  },
  created() {
    this.$tools.getall((data) => {
      this.all = data;
    });
    this.getUserInfo()
  },
  data: () => ({
    userinfo:{},
    all: {},
    // dialogVisible: false,
    manualList:[],
    copyMessageClose:true,
    jumpManualUrl:'',
    userFlag:false
  }),
  components:{tooltip},
  methods: {
    //人核状态
    filterHbStatus(val) {
      if (val == "7") {
        return "核保中";
      } else if (
        val == "1" ||
        val == "2" ||
        val == "3" ||
        val == "5" ||
        val == "9" ||
        val == "-9"
      ) {
        return "核保成功";
      } else if (val == "4" || val == "6") {
        return "核保失败";
      } else if (val == "8") {
        return "已撤销";
      } else {
        return '-'
      }
    },
    getUserInfo(){
      const data = this.$tools.getLocal("userinfo");
      this.userinfo = data
      if(data.level!=3&&data.level!=2){
          this.userFlag = true
      }
    },
    // 复制
    copys(url){
      const cInput = document.createElement('input')
      cInput.value = url
      document.body.appendChild(cInput)
      cInput.select() // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('Copy')
       this.$message({
            message: "复制成功",
            type: "success",
          });
      /// 复制成功后再将构造的标签 移除
      cInput.remove()
    },
    sendMsg(id) {
      console.log(id)
      this.$http({
        url: "/master/order/sendManualMsg",
        type: "get",
        params: {
          orderId: id,
        },
      }).then((res) => {
        if (res.httpCode == 200 && res.msg === "请求成功") {
          this.$notice.msg("发送成功", 1, 1500);
          this.$emit("getRenewalPolicys");
        } else {
          this.$notice.msg("发送失败", 3, 1500);
        }
      });
    },
    // 获取人核进度列表
    getManualRecordList(id) {
      this.$http({
        url: "/master/order/manualRecordList",
        type: "put",
        params: {
          orderId: id,
        },
      }).then(res=>{
        let manualList = res.data
        manualList = manualList.map(item=>{
            if(item){
              let itemArr = item.createTime.replace(/-/g,'/').split(':')
              item.createTime = itemArr[0]+':'+itemArr[1]
              return item
            }
          })
          this.manualList = res.data
      })
      
    },
    // 跳转订单详情
    getOrderDetail(id,mechanName,mechanLevel){
      this.$router.push({
              path: "/order_tbd_detail",
              query: { orderId: id, mechanShortName: mechanName,mechanLevel:mechanLevel },
            });
    },
    // 详情
    getDetail(url) {
      window.open(url)
    },
  },
  filters: {
  },
};
</script>

<style lang='scss' scoped>
@import "./order_rhd_card";
</style>
<style lang='scss'>
.gd-popper{
  padding:0;
  min-width: 97px;
  padding: 4px 10px;
}
</style>